import { Utils } from '@pbt/pbt-ui-components'

import i18n from '~/locales/i18n'
import type { TaskTypesType } from '~/types'

import { TimelineEntryType } from './timelineConstants'

export const TaskState = {
  OPEN: 'Open',
  DUE: 'Due',
  OVERDUE: 'Overdue',
  DONE: 'Done',
}

export const TaskStateV2 = {
  DUE: 'Due',
  OVERDUE: 'Overdue',
  IN_PROGRESS: 'In progress',
  WAITING_FOR_REPLY: 'Waiting for reply',
  DONE: 'Done',
}

export const RecurrenceOptions = {
  DATE_TIME: i18n.t('Constants:TASK_CONSTANTS.DATE_TIME'),
  OCCURRENCES: i18n.t('Constants:TASK_CONSTANTS.OCCURRENCE_ONE_OR_OTHER'),
}

export const CustomDatePrepositions = {
  BEFORE: 'Before',
  AFTER: 'After',
}

export const CustomDatePostfixes = {
  START: 'Start',
  END: 'End',
}

export const CustomDatePrepositionsList = [
  {
    id: CustomDatePrepositions.BEFORE,
    name: CustomDatePrepositions.BEFORE,
    nameTranslation: i18n.t('Time:LABEL.BEFORE'),
  },
  {
    id: CustomDatePrepositions.AFTER,
    name: CustomDatePrepositions.AFTER,
    nameTranslation: i18n.t('Time:LABEL.AFTER'),
  },
]
export const CustomDatePostfixesList = [
  {
    id: CustomDatePostfixes.START,
    name: CustomDatePostfixes.START,
    nameTranslation: i18n.t('Tasks:LABEL.START_ACTION'),
  },
  {
    id: CustomDatePostfixes.END,
    name: CustomDatePostfixes.END,
    nameTranslation: i18n.t('Tasks:LABEL.END_ACTION'),
  },
]

export const RepeatMode = {
  DOES_NOT_REPEAT: i18n.t('Constants:TASK_CONSTANTS.DOES_NOT_REPEAT'),
  REPEAT: i18n.t('Common:REPEAT_ACTION'),
}

export const RepeatModeList = Utils.enumToSelectableList(RepeatMode)

export enum TaskContext {
  SOAP = 'SOAP',
  WHITEBOARD = 'WHITEBOARD',
}

export const RX_REQUEST_TASK_TYPE: TaskTypesType = 'Rx Request'
export const VET_DIET_REQUEST_TASK_TYPE: TaskTypesType = 'Vet Diet Request'

export const FullScreenTasks: TaskTypesType[] = [
  RX_REQUEST_TASK_TYPE,
  VET_DIET_REQUEST_TASK_TYPE,
]

export const UncreatableTasks: TaskTypesType[] = [
  RX_REQUEST_TASK_TYPE,
  VET_DIET_REQUEST_TASK_TYPE,
]

export const RxRequestPrimaryFilters = [
  TimelineEntryType.DIAGNOSIS,
  TimelineEntryType.PRESCRIPTION,
  TimelineEntryType.LAB_TEST,
]

/**
 * Mapping from drug administration frequency names to task recurrence settings.
 * Used for smart defaults when creating tasks from prescriptions.
 *
 * Note: If a frequency is not in this map, components will fall back to daily recurrence.
 * This map matches the logic originally defined in TaskSection.tsx
 */
export const AdminFrequencyToTaskFrequencyMap: Record<
  string,
  { amount: number; unit: string }
> = {
  Hourly: { amount: 1, unit: 'Hour' },
  'Every 2 hours': { amount: 2, unit: 'Hour' },
  'Every 4 hours': { amount: 4, unit: 'Hour' },
  'Every 6 hours': { amount: 6, unit: 'Hour' },
  'Every 8 hours': { amount: 8, unit: 'Hour' },
  'Every 12 hours': { amount: 12, unit: 'Hour' },
  'Every 24 hours': { amount: 24, unit: 'Hour' },
  'Every other day': { amount: 2, unit: 'Day' },
  'Once per week': { amount: 1, unit: 'Week' },
  'Every 30 days': { amount: 30, unit: 'Day' },
  'Once per month': { amount: 1, unit: 'Month' },
  'Every 90 days': { amount: 90, unit: 'Day' },
}
